var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"text-xl-center font-weight-black"},[_vm._v(" BEEP BOOP: Loading the data... ")])}
var staticRenderFns = []

export { render, staticRenderFns }